import { api } from 'api'
import { WorkStatusEnum } from './shiftTimeline'

type GetShiftWorkRequest = {
  companyId: number
  shiftId: number
}

type GetShiftWorkResponseWork = {
  id: number
  status: WorkStatusEnum
  isNoShow: boolean
}

type GetShiftWorkResponse = {
  work: GetShiftWorkResponseWork[]
}

export async function getShiftWork(
  { companyId, shiftId }: GetShiftWorkRequest,
  signal?: AbortSignal
) {
  const response = await api.get<GetShiftWorkResponse>(
    `/company/${companyId}/shifts/${shiftId}/work`,
    { signal }
  )

  return response.data.work
}
